import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/magic.svg'
import gImg1 from '../../images/gallery/cp-img01.jpg'
import gImg2 from '../../images/gallery/cp-img02.jpg'
import gImg3 from '../../images/gallery/cp-img03.jpg'
import gImg4 from '../../images/gallery/cp-img04.jpg'
import gImg5 from '../../images/gallery/cp-img05.jpg'
import gImg6 from '../../images/gallery/cp-img06.jpg'

const PrivacyPage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title cp-page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" />Privacy Policy</span>
                                        <h2 className="title">AllGuard Privacy Policy - Your access and usage rights</h2>
                                        <span className="page-update_time">Updated on : February 26th 2025</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="terms&conditions-section cp-det-bg">
                    <div className="container">
                        <div className="terms-section_inner pt-60 pb-75">
                            <div className="row">
                                <div className="col-lg-11">
                                <div className="item-details-widget">
    <h2 className="item_details_info_title">Data Controller and Data Collection</h2>
    <p>AllGuard.io, as the Data Controller, is dedicated to protecting your privacy in accordance with UK data protection laws, including the UK GDPR and Data Protection Act 2018. We collect Personal Data to deliver our bespoke payment solutions, which may be provided voluntarily by you or collected automatically when you use this site. This data may include, but is not limited to, contact details, account information, preferences, cookies, and usage data from tracking tools.</p>
    <p>Cookies and similar technologies are used solely to enhance your experience, personalize services, and analyze site performance. Certain data, such as contact or payment details, may be required to access specific features—like event platforms, booking systems, or kiosk integrations—ensuring a secure and tailored user journey.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">User Responsibilities</h2>
    <p>You are responsible for any third-party Personal Data you share via AllGuard.io. By providing such data, you confirm your legal right to do so and release AllGuard.io from any liability arising from its use.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Data Processing and Security</h2>
    <p>We process Personal Data using secure IT systems at our UK-based offices and other locations essential to our operations. AllGuard.io implements robust security measures to prevent unauthorized access, alteration, disclosure, or destruction of your data. Access is restricted to authorized personnel (e.g., customer support, technical staff) and trusted third-party service providers (e.g., hosting or payment partners), all bound by confidentiality obligations.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Data Storage and Retention</h2>
    <p>Your Personal Data is retained only for as long as necessary to fulfill the purposes outlined—such as providing payment services—or to comply with legal obligations, including tax and accounting requirements. You may request deletion or suspension of your data at any time by contacting us, subject to any legal retention periods.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Legal Action</h2>
    <p>AllGuard.io may disclose Personal Data to comply with UK legal obligations, respond to requests from public authorities (e.g., HMRC or law enforcement), or protect our rights in legal proceedings related to misuse of our website or services.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">User Rights</h2>
    <p>Under UK GDPR, you have rights over your Personal Data. You may contact AllGuard.io at any time to exercise these rights, including:</p>
    <ul className="privacy-details">
        <li>Access: Request details of the Personal Data we hold about you.</li>
        <li>Rectification: Correct inaccurate or incomplete data.</li>
        <li>Erasure: Request deletion of your data when no longer needed, subject to legal exceptions.</li>
        <li>Portability: Obtain your data in a structured, machine-readable format.</li>
        <li>Restriction: Limit processing in specific circumstances.</li>
        <li>Objection: Oppose processing for marketing or where based on legitimate interests.</li>
        <li>Consent Withdrawal: Revoke consent where processing relies on it.</li>
        <li>Complaint: Lodge a complaint with the UK Information Commissioner’s Office (ICO) if you believe your rights are infringed.</li>
    </ul>
    <p>Requests should be directed to our Data Controller via the contact details below.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">"Do Not Track" Requests</h2>
    <p>AllGuard.io does not currently respond to “Do Not Track” signals. For details on how third-party services we use handle such requests, please consult their privacy policies.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Policy Updates</h2>
    <p>We may revise this Privacy Policy to reflect legal or operational changes. Updates will be posted here, and your continued use of AllGuard.io signifies acceptance of the latest terms. We encourage regular review of this page.</p>
</div>


<div className="item-details-widget">
    <h2 className="item_details_info_title">Contact</h2>
    <p>For questions about this Privacy Policy or to exercise your rights, please <Link onClick={ClickHandler} to="/contact" className="details-link">click here</Link> to reach us. You can also email us at: <a href="mailto:hello@allguard.io">hello@allguard.io</a>.</p>
</div>
                                 
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <CtaSection cClassNamclassName={'bg'} />
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacyPage;
